import { featureFlagService } from '@superbet-group/web.lib.flags';

const MultiMarketSelectFeatureFlag = 'sports-offer.is-market-multi-select-enabled';

export function getMultiMarketSelectEnabledFlag(): Promise<boolean> {
    return featureFlagService.getFeatureValue(MultiMarketSelectFeatureFlag, false);
}
